import { Box, ModBox, Text } from '@jfs/ui-new'
import React from 'react'

const TitleWithDashedLine = ({ title }: any) => {
  return (
    <ModBox direction="row" w={'93.5%'} alignItems={'center'} justifyContent={'space-between'}>
      <ModBox marginRight={16}>
        <Text title={title} fontFamily="jiotype-bold" fontSize={14} />
      </ModBox>
      <Box borderStyle={'dashed'} borderColor={'BORDER_COLOR'} borderWidth={1} w={'93.5%'} marginRight={100} />
    </ModBox>
  )
}

export { TitleWithDashedLine }
